<template>
  <div>
    <div class="wreppar">
      <div class="headers">
        <Header></Header>
      </div>
      <div class="block">
        <el-carousel height="5rem">
          <el-carousel-item v-for="(item,index) in img" :key="index">
            <img :src="item.src" alt class="block_img" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="centent">
        <div class="centent_child">
          <div class="centent_childs clearfix">
            <div class="centent_lie">
              <img src="../../assets/touxiang.png" alt />
            </div>
            <div class="centent_right">
              <p class="centent_guo">中国围棋</p>
              <p class="centent_nei">大会内容丰富,比赛形式多样,共有16项之专题>></p>
            </div>
          </div>
          <div class="centent_childs clearfix">
            <div class="centent_lie">
              <img src="../../assets/touxiang.png" alt />
            </div>
            <div class="centent_right">
              <p class="centent_guo">中国象棋</p>
              <p class="centent_nei">大会内容丰富,比赛形式多样,共有16项专题>></p>
            </div>
          </div>
          <div class="centent_childs clearfix">
            <div class="centent_lie">
              <img src="../../assets/touxiang.png" alt />
            </div>
            <div class="centent_right">
              <p class="centent_guo">国际象棋</p>
              <p class="centent_nei">大会内容丰富,比赛形式多样,共有16项之专题>></p>
            </div>
          </div>
        </div>
        <div class="centent_biao">
          <div class="biao_top">
            <p class="biao_sai">热点赛事</p>
            <p class="biao_ti">面对所有围棋爱好者的大型赛事活动</p>
          </div>
          <div class="biao_lie">
            <div class="biao_he" v-for="(item,index) in matchData" @click="details(index)">
              <div class="biao_biao">
                <!-- <img src="../../assets/1.jpg" alt /> -->
                <img :src="item.image.substring(2,item.image.length-2)" alt />
              </div>
              <div class="biao_hes">
                <P class="biaoti">{{item.title}}</P>
                <P class="biao_dian">{{Number(item.click)}}点击</P>
              </div>
            </div>
          </div>
        </div>
        <div class="centent_zhong">
          <div class="centent_mi">
            <p>中国围棋大会升段秘籍</p>
            <p>中国围棋大会升段秘籍</p>
            <p>中国围棋大会升段秘籍</p>
          </div>
        </div>
        <div class="centent_shi">
          <div class="centent_saishi clearfix">
            <p>赛事新闻</p>
            <p>赛事点评</p>
            <p>活动预报</p>
          </div>
          <div class="centent_xin clearfix">
            <div class="centent_wen">
              <div class="xinwen_img">
                <img src="../../assets/saishi.jpg" alt />
              </div>
              <div class="centent_ziti">
                <p>第34届同里杯中国围棋天元赛开幕</p>
                <p>2020第八届贺岁杯中日韩新春围棋争霸赛20日打响</p>
                <p>晚报杯落幕潘文君夺冠升七段 新民晚报获团体第一</p>
                <!-- <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落</p>
                <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落</p>-->
              </div>
            </div>
            <div class="centent_wen">
              <div class="xinwen_img">
                <img src="../../assets/dianping.jpg" alt />
              </div>
              <div class="centent_ziti">
                <p>第24届新人王2月10日展开本赛争夺 小将周泓余能否卫冕冠军</p>
                <p>
                  第5届洛阳白云山杯中国围棋棋圣战拉开帷幕
                  第11届中国围棋龙星战
                </p>
                <p>"阆中古城杯"第二届中国女子围棋名人战</p>
                <!-- <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落</p>
                <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落</p>-->
              </div>
            </div>
            <div class="centent_wen">
              <div class="xinwen_img">
                <img src="../../assets/yubao.jpg" alt />
              </div>
              <div class="centent_ziti">
                <p>第24届中国围棋新人王赛规程</p>
                <p>第十三届“春兰杯”世界职业围棋锦标赛规程</p>
                <!-- <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落</p>
                <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落</p>
                <p>2017年夏季湛江市少儿围棋定级升级比赛本周日落asdadsadasd</p>-->
              </div>
            </div>
          </div>
        </div>
        <div class="centent_bottom">
          <div class="biao_top biao_bottom">
            <p class="biao_sai">精彩图集</p>
            <p class="biao_ti">面对所有围棋爱好者的大型赛事活动</p>
          </div>
          <el-carousel height="200px" direction="vertical" :autoplay="true" :interval="1000">
            <el-carousel-item v-for="(item,index) in bottom" :key="index">
              <div class="bottom_img">
                <div class="bottom_imgchild" v-for="item in item.bottom_img">
                  <img :src="item.src" alt />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>

          <div class="centent_qing">
            <div class="youqing">友情链接></div>
            <div class="qing_lian">
              <img src="../../assets/temp12.jpg" alt class="lian_img" />
              <img src="../../assets/temp12.jpg" alt class="lian_img" />
              <img src="../../assets/temp12.jpg" alt class="lian_img" />
              <img src="../../assets/temp12.jpg" alt class="lian_img" />
              <img src="../../assets/temp12.jpg" alt class="lian_img" />
              <img src="../../assets/temp12.jpg" alt class="lian_img" />
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
export default {
  data() {
    return {
      page: "1",
      pageSize: "8",
      img: [
        {
          src: require("../../assets/lun2.jpg")
        },
        {
          src: require("../../assets/lun1.jpg")
        },
        {
          src: require("../../assets/lun3.jpg")
        },

        {
          src: require("../../assets/lun4.jpg")
        }
      ],
      bottom: [
        {
          bottom_img: [
            {
              src: require("../../assets/1.jpg")
            },
            {
              src: require("../../assets/2.jpg")
            },
            {
              src: require("../../assets/3.jpg")
            },
            {
              src: require("../../assets/4.jpg")
            }
          ]
        },
        {
          bottom_img: [
            {
              src: require("../../assets/5.jpg")
            },
            {
              src: require("../../assets/6.jpg")
            },
            {
              src: require("../../assets/7.jpg")
            },
            {
              src: require("../../assets/8.jpg")
            }
          ]
        },
        {
          bottom_img: [
            {
              src: require("../../assets/9.jpg")
            },
            {
              src: require("../../assets/10.jpg")
            },
            {
              src: require("../../assets/11.jpg")
            },
            {
              src: require("../../assets/12.jpg")
            }
          ]
        }
      ],
      matchData: []
    };
  },
  components: { Header, Footer },
  watch: {},
  mounted() {
    const rLoading = this.openLoading();
    let that = this;
    that.$http
      .get(
        that.g.ajaxurl +
          "attentions/indexw?page=" +
          that.page +
          "&pageSize=" +
          that.pageSize
      )
      .then(res => {
        that.matchData = res.data.data.items;
        rLoading.close();
      });
  },
  methods: {
    details: function(a) {
      this.$router.push({
        path: "/Tournament",
        query: {
          id: this.matchData[a].id
        }
      });
    }
  }
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
}
.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}
.wreppar {
  width: 100%;
  font-family: "微软雅黑";
}
.headers {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.block {
  width: 100%;
  font-size: 0;
  margin-top: 1.841rem;
}
.block_img {
  width: 100%;
  height: 100%;
}
.centent {
  width: 100%;
}
.centent_child {
  width: 76%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 0.3rem;
}
.centent_childs {
  display: flex;
  justify-content: flex-start;
}
.centent_lie {
  width: 1rem;
  height: 1rem;
}
.centent_lie img {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  float: left;
}
.centent_right {
  margin-left: 0.1rem;
  cursor: default;
}
.centent_guo {
  font-size: 0.22rem;
}
.centent_nei {
  font-size: 0.18rem;
}
.centent_biao {
  width: 76%;
  margin: 0 auto;
}
.biao_top {
  width: 100%;
  text-align: center;
  margin-top: 0.4rem;
  cursor: default;
}
.biao_ti {
  font-size: 0.26rem;
  margin-top: 0.1rem;
}
.biao_sai {
  font-size: 0.4rem;
  color: #e50006;
  font-weight: bold;
}
.biao_lie {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.3rem;
}
.biao_he {
  margin-top: 0.2rem;
  cursor: pointer;
}
.biao_biao {
  width: 3rem;
  height: 1.9rem;
}
.biao_biao img {
  width: 3rem;
  height: 1.9rem;
}
.biaoti {
  width: 2.2rem;
  overflow: hidden;
  font-size: 0.16rem;
  line-height: 0.3rem;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.biao_hes {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.05rem;
}
.biao_hes:hover {
  color: #fe8f24;
}
.biao_dian {
  background: #e50006;
  font-size: 0.16rem;
  color: #fff;
  padding: 0.02rem;
}
.centent_zhong {
  width: 100%;
  background: #ccc;
  margin-top: 0.3rem;
}
.centent_mi {
  display: flex;
  justify-content: space-between;
  width: 76%;
  margin: 0 auto;
  font-size: 0.2rem;
  line-height: 0.57rem;
  cursor: default;
}
.centent_shi {
  width: 76%;
  margin: 0 auto;
  margin-top: 0.3rem;
}
.centent_saishi {
  font-size: 0.2rem;
  width: 100%;
}
.centent_saishi p {
  float: left;
  width: 33%;
  text-align: center;
  cursor: default;
}
.centent_xin {
  margin-top: 0.3rem;
}
.centent_wen {
  width: 33.3%;
  float: left;
}
.xinwen_img {
  width: 4.4rem;
  height: 2.2rem;
}
.xinwen_img img {
  width: 4.4rem;
  height: 2.2rem;
}
.centent_ziti {
  font-size: 0.2rem;
  margin-top: 0.1rem;
  cursor: default;
}
.centent_ziti p {
  width: 4.4rem;
  margin-top: 0.01rem;
  height: 0.25rem;
  line-height: 0.25rem;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.centent_bottom {
  width: 100%;
  margin-top: 0.3rem;
  margin-bottom: 0.6rem;
}
.biao_bottom {
  margin-bottom: 0.3rem;
}
.bottom_img {
  width: 76%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.bottom_imgchild {
  width: 22%;
  height: 2.4rem;
  margin-top: 0.2rem;
}
.bottom_imgchild img {
  width: 100%;
  height: 2rem;
}
.centent_qing {
  width: 76%;
  margin: 0 auto;
  margin-top: 0.6rem;
}
.youqing {
  font-size: 0.2rem;
}
.qing_lian {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.3rem;
}
.lian_img {
  width: 1.6rem;
  padding: 0.1rem;
  border: solid 1px #ccc;
  margin-left: 0.2rem;
}
.lian_img:nth-of-type(1) {
  margin-left: 0.5rem;
}
.footer {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/page/index.vue